import React, { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Ticket } from 'lucide-react';
import SportsCoupons from './SportsCoupons';
import './sportsBets.css';

// Sayfa **tek liste** çizer: sitenin kendi sportsbook'unun kuponları
// (``coupons`` tablosu) ve hazır bir spor kitabından (Flexrix / Betby)
// oynanan bahisler birlikte. İkisi ayrı kayıtlardır — hazır kupon
// sağlayıcıda durur, bize yalnızca para hareketi gelir — ama yönetici için
// tek bir soru vardır: "bu üye spora ne oynamış". Bu yüzden ikisi ayrı
// sekmelere bölünmez; satır kaynağını rozetiyle söyler.

// Spor Bahisleri — bütün üyelerin spor kuponlarının kendi bölümü.
//
// Liste bir süre Oyun Kontrol → Spor & Cashout sayfasının içinde bir bölüm
// olarak duruyordu; ayarların dibinde açılıp kapanan bir panelde denetim
// yapılamıyordu. Sayfa artık ayrı bir rotadır, böylece adres paylaşılabilir ve
// süzgeç adres çubuğunda taşınır.
//
// **Özel oran süzgeci URL'dedir.** Özel Oranlar bölümündeki "Kuponlar" düğmesi
// bu sayfayı ``?override=<imza>`` ile açar; süzgeç bileşen state'inde
// tutulsaydı yönetici sayfayı yenilediğinde ya da bağlantıyı paylaştığında
// liste sessizce bütün kuponlara dönerdi. İmza biçimi backend'in kupona
// yazdığı anahtarla aynıdır (services/odds_override.pick_signature).
//
// Bu dosya yalnızca rota kabuğudur: başlık, adres çubuğundaki süzgeç ve
// listenin kendisi. Yerleşim ve renkler sayfaya özel `sportsBets.css`
// içindedir (KYC sayfasındaki düzenin aynısı) — `admin-*` bileşenlerine
// dokunulmaz.

const SportsBets = () => {
  const [params, setParams] = useSearchParams();

  const override = useMemo(() => {
    const signature = params.get('override');
    if (!signature) return null;
    return { signature, label: params.get('override_label') || '' };
  }, [params]);

  const clearOverride = useCallback(() => {
    setParams((current) => {
      const next = new URLSearchParams(current);
      next.delete('override');
      next.delete('override_label');
      return next;
    }, { replace: true });
  }, [setParams]);

  return (
    <div className="sbet-page">
      <header className="sbet-head">
        <div className="sbet-head-icon">
          <Ticket size={21} aria-hidden="true" />
        </div>
        <div className="sbet-head-text">
          <h1>Spor Bahisleri</h1>
          <p>
            Bütün üyelerin spor kuponları tek listede: sitenin kendi
            sportsbook&apos;u ve hazır spor kitabı (BetConstruct / Betby). Satırın
            hangi kaynaktan geldiğini rozeti söyler; hazır kuponu sağlayıcı
            sonuçlandırır, panelden karara bağlanamaz.
          </p>
        </div>
      </header>

      <SportsCoupons override={override} onClearOverride={clearOverride} />
    </div>
  );
};

export default SportsBets;
